import ChromeBox from './ChromeBox';

export default ChromeBox;
